import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, BehaviorSubject } from 'rxjs';

export interface DialogInfo {
  modalMsg: string;
  hideButton: boolean;
}

@Component({
    selector: 'app-message-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MessageModalComponent>, @Inject
    (MAT_DIALOG_DATA) public data: DialogInfo) { }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    // If modal just displays "Error" then this did not update, confirm msg was passed properly
    document.getElementById('pageMsg')!.innerHTML = this.data.modalMsg;
    if (this.data.hideButton) { document.getElementById('btnOK')!.style.display = "none"; }
    else { document.getElementById('btnOK')!.style.display = ""; }
  }

  updateText(newText: string) {
    var i = 0;
    document.getElementById('pageMsg')!.innerHTML = newText;
  }
}
